import React from 'react';
import {View, ViewStyle} from 'react-native';

import {LoadingBox} from '/component/base/LoadingBox';

import {styles} from './Loading.style';

type LoadingProps = {
  style: ViewStyle;
};

export const Loading: React.FC<LoadingProps> = ({style = {}}) => {
  const combinedStyle = [styles.container, style];

  return (
    <View style={combinedStyle}>
      <View>
        <LoadingBox style={styles.avatar} />
      </View>
      <View style={styles.informationContainer}>
        <LoadingBox style={styles.name} />
        <LoadingBox style={styles.rank} />
      </View>
    </View>
  );
};
